export const MEETING_RECAP_TAB_KEY = "meetingRecapTab";
export const CONTENT_TAB_KEY = "contentTab";
export const MEETING_BRIEFING_TAB_KEY = "meetingBriefingTab";
export const MEETING_BRIEFING_EXPERIMENT_TAB_KEY = "meetingBriefingExperimentTab";
